export enum TableColumnKey {
  SettlementDate = 'settlementDate',
  ProgramName = 'programName',
  Repayment = 'repayment',
  TotalTransactionAmount = 'totalTransactionAmount',
  Payment = 'payment',
  PaMarkup = 'paMarkup',
  AnnualFee = 'annualFee',
  VisaRebate = 'visaRebate',
  PaRebate = 'paRebate',
  totalAgentInterest = 'totalAgentInterest',
}

export interface TableRow {
  id: number;
  [TableColumnKey.SettlementDate]: string;
  [TableColumnKey.ProgramName]: string;
  [TableColumnKey.Repayment]: string;
  [TableColumnKey.TotalTransactionAmount]: string;
  [TableColumnKey.Payment]: string;
  [TableColumnKey.PaMarkup]: string;
  [TableColumnKey.AnnualFee]: string;
  [TableColumnKey.VisaRebate]: string;
  [TableColumnKey.PaRebate]: string;
  [TableColumnKey.totalAgentInterest]: string;
  rawData: any;
}
